<script>
import ExcelBook from "../../utils/excelbook";
import {
  alingHeadertext,
  fontHeadertext,
  fillHeadertext,
  borderHeadertext,
  formatDate,
  styleNumber,
} from "../../utils/funciones";
export default {
  name: "GeneraExcel",
  methods: {
    data() {
      return {};
    },
    generarExcel({
      items,
      tipodoc,
      cliente: { Direccion, Rif, NombreCli, Telefonos },
    }) {
      const book = new ExcelBook(`PendientesEmpresa`);
      const ItemDocumentosPendientes = [...items];
      const resumenSaldos = [
        "RESUMEN DE SALDOS",
        "PENDIENTE",
        "VENCIDO",
        "POR VENCER",
      ];

      const uniqueTipoDoc = Array.from(
        new Set(ItemDocumentosPendientes.map((item) => item.TipoDoc))
      );

      let itemsTipoDoc = [];
      uniqueTipoDoc.forEach((siglas) => {
        let tipoDocObj = tipodoc.find((obj) => obj.Siglas === siglas);

        if (tipoDocObj) {
          itemsTipoDoc.push({ TipoDoc: siglas, Nombre: tipoDocObj.Nombre });
        }
      });
      const itemsTipoDocSorted = itemsTipoDoc.sort((a, b) => {
        if (b.TipoDoc < a.TipoDoc) return -1;
        if (b.TipoDoc > a.TipoDoc) return 1;
        return 0;
      });
      const arrNombreTipoDoc = itemsTipoDocSorted.map((item) => item.Nombre);
      const resumenDocs = [
        "RESUMEN DE DOCUMENTOS PENDIENTES",
        ...arrNombreTipoDoc,
        "TOTAL DOCUMENTOS",
      ];

      const CELLINICIO =
        uniqueTipoDoc.length > 2 ? uniqueTipoDoc.length + 10 : 12;
      const colsSuma = ["G", "H", "I", "J", "K", "L"];
      const infoCliente = {
        GRUPO: `${NombreCli}(R.I.F:${Rif})`,
        DIRECCION: Direccion,
        TELEFONO: Telefonos,
      };

      const ENCABEZADOFIJO = 6;

      let rowIndex = CELLINICIO;
      let currentDate = new Date();
      let dateFormat = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(currentDate);
      let footerSaldo = [];
      const columnsPendienteCliente = [
        {
          header: "CODIGO CLIENTE",
          key: "Empresa",
          width: 10,
          style: { font: { name: "Arial", size: 8, bold: true } },
        },

        {
          header: "NUMERO DE DOCUMENTO",
          key: "NumeroDoc",
          width: 15,
          style: { font: { name: "Arial", size: 8 } },
        },
        {
          header: `TIPO DOC`,
          key: "TipoDoc",
          width: 5,
          style: {
            font: { name: "Arial", size: 8 },
            alignment: { horizontal: "center" },
          },
        },
        {
          header: `FECHA EMISION`,
          key: "FechaEmision",
          width: 10,
          style: {
            numFmt: "dd/mm/yy",
            font: { name: "Arial", size: 8 },
            alignment: { horizontal: "center" },
          },
        },
        {
          header: `FECHA ENTREGA`,
          key: "FechaEntregaCli",
          width: 10,
          style: {
            numFmt: "dd/mm/yy",
            font: { name: "Arial", size: 8 },
            alignment: { horizontal: "center" },
          },
        },
        {
          header: `FECHA VENCE`,
          key: "FechaVence",
          width: 10,
          style: {
            numFmt: "dd/mm/yy",
            font: { name: "Arial", size: 8 },
            alignment: { horizontal: "center" },
          },
        },
        {
          header: `MONTO ORIGINAL USD`,
          key: "MontoOriginal",
          width: 11,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;-",
            font: { name: "Arial", size: 8 },
          },
        },
        {
          header: `RETENCION IVA POR COBRAR`,
          key: "MontoRetIva",
          width: 11,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;0.00",
            font: { name: "Arial", size: 8 },
          },
        },
        {
          header: `MONTO POR COBRAR`,
          key: "MontoPagar",
          width: 15,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;-",
            font: { name: "Arial", size: 8 },
          },
        },

        {
          header: `SALDO USD`,
          key: "SaldoPendiente",
          width: 15,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;-",
            font: { name: "Arial", size: 8 },
          },
        },
        {
          header: `MONTO ORIGINAL BS  `,
          key: "MontoOriginalBs",
          width: 12,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;-",
            font: { name: "Arial", size: 8 },
          },
        },
        {
          header: `SALDO BS`,
          key: "SaldoPendienteBs",
          width: 15,
          style: {
            numFmt: "#,##0.00;[Red]-#,##0;-",
            font: { name: "Arial", size: 8 },
          },
        },
        {
          header: `DIAS MORA`,
          key: "DiasMora",
          width: 8,
          style: {
            font: { name: "Arial", size: 8, color: { argb: "FFFF0000" } },
            alignment: { horizontal: "right" },
          },
        },
        {
          header: `MONEDA GESTION`,
          key: "nomMoneda",
          width: 10,
          style: { font: { name: "Arial", size: 8 } },
        },
      ];

      const rowsExcel = ItemDocumentosPendientes.map((id) => {
        let newObj = { ...id };
        newObj.FechaEntregaCli = formatDate({ obj: id.FechaEntregaCli });
        newObj.FechaEmision = formatDate({ obj: id.FechaEmision });
        newObj.FechaVence = formatDate({ obj: id.FechaVence });
        newObj.MontoOriginal = id.MontoOriginal[1];
        newObj.MontoOriginalBs = id.MontoOriginal[0];
        newObj.MontoRetIva = id.MontoRetIva[id.TipoMoneda];
        newObj.MontoPagar = id.MontoPagar[id.TipoMoneda];
        newObj.SaldoPendiente = id.SaldoPendiente[1];
        newObj.SaldoPendienteBs = id.SaldoPendiente[0];
        return newObj;
      });

      const groupedRows = rowsExcel.reduce((grouped, row) => {
        (grouped[row.StatusDoc] = grouped[row.StatusDoc] || []).push(row);
        return grouped;
      }, {});

      book.workbook.eachSheet((worksheet) => {
        book.addColumns({
          columns: columnsPendienteCliente,
          ws: worksheet,
          inicio: CELLINICIO,
        });
        const headerRow = worksheet.getRow(CELLINICIO);
        headerRow.eachCell(function (cell) {
          cell.style.alignment = alingHeadertext;
          cell.style.font = fontHeadertext({ fontSize: 8, isBold: true });
          cell.style.fill = fillHeadertext;
          cell.style.border = borderHeadertext;
        });
        for (const statusDoc in groupedRows) {
          groupedRows[statusDoc].sort((a, b) => {
            if (b.TipoDoc < a.TipoDoc) return -1;
            if (b.TipoDoc > a.TipoDoc) return 1;
            return 0;
          });
          const rows = groupedRows[statusDoc];

          for (const row of rows) {
            const clienteRow = worksheet.addRow(row);
            clienteRow.eachCell((cell) => {
              cell.border = borderHeadertext;
            });
          }
          const subtotalRow = worksheet.addRow({ FechaVence: statusDoc });
          worksheet.addRow();

          for (const col of colsSuma) {
            let cell = (subtotalRow.getCell(col).value = {
              formula: `SUM(${col}${rowIndex + 1}:${col}${
                rowIndex + rows.length
              })`,
            });
            cell.font = { bold: true, name: "Arial", size: 8 };
            footerSaldo.push(rowIndex + 1 + rows.length);
            subtotalRow.commit();
          }
          subtotalRow.eachCell((cell) => {
            cell.font = { bold: true, name: "Arial", size: 8 };
          });
          rowIndex += rows.length + 2;
        }
        const celdaVencido = book.searchCell({
          ws: worksheet,
          text: resumenSaldos[2],
        });
        const celdaPorVencer = book.searchCell({
          ws: worksheet,
          text: resumenSaldos[3],
        });

        let rowIndexCli = 1;
        for (const key in infoCliente) {
          book.addValueToCell({
            ref: `A${rowIndexCli}`,
            value: key,
            ws: worksheet,
          });
          book.addValueToCell({
            ref: `B${rowIndexCli}`,
            value: infoCliente[key],
            ws: worksheet,
          });
          rowIndexCli++;
        }
        resumenDocs.forEach((value, index) => {
          book.addValueToCell({
            ref: `G${index + 6}`,
            value: value,
            ws: worksheet,
          });
          book.mergeCells({
            desde: `G${index + 6}`,
            hasta: `H${index + 6}`,
            ws: worksheet,
          });
        });

        itemsTipoDocSorted.forEach((item) => {
          item.sumaDocUsd = 0;
          item.sumaDocBs = 0;
        });

        worksheet.eachRow((row, rowNumber) => {
          // Recorre cada celda de la fila
          row.eachCell((cell, colNumber) => {
            let item = itemsTipoDocSorted.find(
              (item) => item.TipoDoc === cell.value
            );
            if (item && cell.value === item.TipoDoc) {
              //`=SumIf(C${CELLINICIO+1}:C${ rowIndex + rows.length},"${value.TipoDoc}",J${CELLINICIO+1}:J${ rowIndex + rows.length})`,
              item.sumaDocUsd += row.getCell("SaldoPendiente").value;
              item.sumaDocBs += row.getCell("SaldoPendienteBs").value;
            }
          });
        });

        itemsTipoDocSorted.forEach((value, index) => {
          book.addValueToCell({
            ref: `I${index + 7}`,
            value: value.sumaDocUsd,
            ws: worksheet,
          });
          book.addValueToCell({
            ref: `J${index + 7}`,
            value: value.sumaDocBs,
            ws: worksheet,
          });
        });
        //formula total documentos usd y bs
        const celdaResta =
          arrNombreTipoDoc.length > 1 ? arrNombreTipoDoc.length : 3;
        book.applySingleFormula({
          cell: `I${CELLINICIO - celdaResta}`,
          formula: `=SUM(I7:I${arrNombreTipoDoc.length + ENCABEZADOFIJO})`,
          ws: worksheet,
        });
        book.applySingleFormula({
          cell: `J${CELLINICIO - celdaResta}`,
          formula: `=SUM(J7:J${arrNombreTipoDoc.length + ENCABEZADOFIJO})`,
          ws: worksheet,
        });

        const uniqueGroupCol = Array.from(new Set(footerSaldo));
        let totalSaldoUsd = [];
        let totalSaldoBs = [];
        for (const valor of uniqueGroupCol) {
          totalSaldoUsd.push(`J${valor}`);
          totalSaldoBs.push(`L${valor}`);
        }
        const totalPendienteUsd = totalSaldoUsd.join("+");
        const totalPendienteBs = totalSaldoBs.join("+");
        book.applySingleFormula({
          cell: `B7:B7`,
          formula: `=${totalPendienteUsd}`,
          ws: worksheet,
        });
        book.applySingleFormula({
          cell: `C7:C7`,
          formula: `=${totalPendienteBs}`,
          ws: worksheet,
        });
        if(celdaVencido){
          book.applySingleFormula({
          cell: `B8:B8`,
          formula: `=J${celdaVencido}`,
          ws: worksheet,
        });
        book.applySingleFormula({
          cell: `C8:C8`,
          formula: `=L${celdaVencido}`,
          ws: worksheet,
        });
        }
        if(celdaPorVencer){
           book.applySingleFormula({
          cell: `B9:B9`,
          formula: `=J${celdaPorVencer}`,
          ws: worksheet,
        });
        book.applySingleFormula({
          cell: `C9:C9`,
          formula: `=L${celdaPorVencer}`,
          ws: worksheet,
        }); 
        }

      

        resumenSaldos.forEach((value, index) => {
          book.addValueToCell({
            ref: `A${index + 6}`,
            value: value,
            ws: worksheet,
          });
        });
        book.addValueToCell({
          ref: `A4`,
          value: `ESTADO DE CUENTA PENDIENTE  AL ${dateFormat}`,
          ws: worksheet,
        });
        book.formatStyle({
          ws: worksheet,
          range: `A4:A4`,
          style: {
            alignment: { horizontal: "center" },
            font: {
              bold: true,
              size: 10,
              name: "Arial",
              color: { argb: "ffff0000" },
            },
          },
        });
        book.addValueToCell({
          ref: `A${CELLINICIO - 1}`,
          value: `DETALLE DE ESTADO DE CUENTA`,
          ws: worksheet,
        });
        book.formatStyle({
          ws: worksheet,
          range: `A${CELLINICIO - 1}:A${CELLINICIO - 1}`,
          style: {
            alignment: { horizontal: "center" },
            font: {
              bold: true,
              size: 8,
              name: "Arial",
              color: { argb: "ffff0000" },
            },
          },
        });
        book.mergeCells({
          desde: `A${CELLINICIO - 1}`,
          hasta: `K${CELLINICIO - 1}`,
          ws: worksheet,
        });
        book.mergeCells({ desde: `A4`, hasta: `J4`, ws: worksheet });
        for (let i = ENCABEZADOFIJO; i <= 9; i++) {
          let desde = `C${i}`;
          let hasta = `D${i}`;
          book.mergeCells({ desde, hasta, ws: worksheet });
        }

        const columnsConfig = {
          A: { alignment: "right", color: { argb: "FF0000FF" } },
          B: { alignment: "left" },
        };

        for (let i = 1; i <= 3; i++) {
          for (let column in columnsConfig) {
            let cell = worksheet.getCell(`${column}${i}`);
            let originalFont = cell.font;
            cell.alignment = { horizontal: columnsConfig[column].alignment };
            cell.font = {
              ...originalFont,
              bold: true,
              color: columnsConfig[column].color,
            };
          }
        }
        let cellsConfig = {
          A6: null,
          G6: null,
        };

        for (let cellRef in cellsConfig) {
          let cell = worksheet.getCell(cellRef);
          let originalFont = cell.font;
          cell.font = {
            ...originalFont,
            bold: true,
            color: { argb: "FF0000FF" },
          };
        }
        const borderStyle = { style: "thin" };

        for (let row = ENCABEZADOFIJO + 1; row <= 9; row++) {
          let cell = worksheet.getCell(`A${row}`);
          let originalFont = cell.font;
          cell.font = { ...originalFont, bold: true };
          for (let col = 1; col <= 3; col++) {
            let cell = worksheet.getCell(row, col);
            cell.border = {
              top: borderStyle,
              left: borderStyle,
              bottom: borderStyle,
              right: borderStyle,
            };
          }
        }
        for (let row = ENCABEZADOFIJO; row <= 9; row++) {
          for (let col = 2; col <= 3; col++) {
            let cell = worksheet.getCell(row, col);
            cell.numFmt = styleNumber.numFmt;
          }
        }
        let numdoc = arrNombreTipoDoc.length;

        for (let row = ENCABEZADOFIJO + 1; row <= 6 + numdoc; row++) {
          for (let col = ENCABEZADOFIJO + 1; col <= 10; col++) {
            let cell = worksheet.getCell(row, col);
            cell.border = {
              top: borderStyle,
              left: borderStyle,
              bottom: borderStyle,
              right: borderStyle,
            };
          }
        }
        for (let row = ENCABEZADOFIJO; row <= numdoc + ENCABEZADOFIJO; row++) {
          let cell = worksheet.getCell(`G${row}`);
          let originalFont = cell.font;
          cell.font = { ...originalFont, bold: true };
        }
        function applyBoldStyle(cell) {
          let originalFont = cell.font;
          cell.font = { ...originalFont, bold: true };
        }
        let colResumenDocs = worksheet.getCell(
          `G${numdoc + ENCABEZADOFIJO + 1}`
        );
        let cellTotalUsd = worksheet.getCell(`I${numdoc + ENCABEZADOFIJO + 1}`);
        let cellTotalBs = worksheet.getCell(`J${numdoc + ENCABEZADOFIJO + 1}`);
        applyBoldStyle(cellTotalUsd);
        applyBoldStyle(cellTotalBs);
        applyBoldStyle(colResumenDocs);
        book.unMergeCells({
          desde: `G${ENCABEZADOFIJO}`,
          hasta: `J${ENCABEZADOFIJO}`,
          ws: worksheet,
        });
        book.mergeCells({
          desde: `G${ENCABEZADOFIJO}`,
          hasta: `J${ENCABEZADOFIJO}`,
          ws: worksheet,
        });
        book.mergeCells({ desde: `B1`, hasta: `G1`, ws: worksheet });
      });

      book.downloadFile(`Documentos Pendientes Cliente ${NombreCli} `);
    },
  },
};
</script>
